module.exports = __webpack_public_path__ + "static/media/feature.8b260727.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/PrinceHotel/feature.jpg
// module id = 250
// module chunks = 0